import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import PrivacyContentFromMarkdown from '../components/Privacy/PrivacyContentFromMarkdown';
import $ from 'jquery';
import { PrinterIcon } from '@heroicons/react/24/solid';

export default function Privacy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Privacy-policy',
    title: 'Privacy Policy',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number], 
      filename: 'privacy-policy.pdf',
      image: { type: 'jpeg' as 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as 'portrait' },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Privacy Policy</title>
        <meta
          name="description"
          content="This Privacy Policy explains our practices regarding the use of personal data collected and processed through our website, contacts with third parties and the provision of services."
        />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/Privacy-policy" />
        <meta property="og:title" content="DISGENET: Privacy Policy" />
        <meta
          property="og:description"
          content="MedBioinformatic Solutions SL (“MedBio”, the “Company”, or “we/us”), is committed to protecting the privacy of all users (“You/r”) of our website and services."
        />
      </Helmet>

      <section>
        <link rel="canonical" href="/Privacy-policy" />
        <div className="container txt-contenido text-right">
          <button
            className="btn bg-light rounded-circle mr-12"
            onClick={downloadSummary}
            title="Download PDF"
          >
            <PrinterIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="container txt-contenido" id="printer">
          <PrivacyContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
}
